import { UntypedFormGroup } from '@angular/forms';
import { DateTimeUtility } from 'src/shared/utility/date-time.utility';
import { BaseResponse } from './base-response.model';
import { TravelItinerarySummaryJSON } from 'src/shared/models/travel-itinerary-summary.model';

export class TravelItinerarySearchResponse extends BaseResponse {
	constructor(
		public message: string,
		public searchResult: TravelItinerarySummaryJSON[],
		public options: TravelItinerarySearchJSON
	) {
		super(message);
	}
}

export interface TravelItinerarySearchJSON {
	search: string;
	filterByDepartureDate: boolean;
	departureDateFrom: string;
	departureDateTo: string;
	type: string;
	onlyCancelled: boolean;
	includeArchivedTravelers: boolean;
	onlyMyTravel: boolean;
	onlyMyApprovals: boolean;
	travelerId: number;
	searchByInitiator: boolean;
	requestStatus: string;
}

export class TravelItinerarySearch {
	constructor(
		public search: string,
		public filterByDepartureDate: boolean,
		public departureDateFrom: string,
		public departureDateTo: string,
		public type: string,
		public onlyCancelled: boolean,
		public includeArchivedTravelers: boolean,
		public onlyMyTravel: boolean,
		public onlyMyApprovals: boolean,
		public travelerId: number,
		public searchByInitiator: boolean,
		public requestStatus: string
	) {}

	static fromJSON(json: TravelItinerarySearchJSON): TravelItinerarySearch {
		const search = Object.create(TravelItinerarySearch.prototype);
		return Object.assign(search, json, {});
	}

	static getSearchOptions(
		searchForm: UntypedFormGroup
	): TravelItinerarySearch {
		return new TravelItinerarySearch(
			searchForm.value['search'],
			searchForm.value['filterByDepartureDate'],
			DateTimeUtility.toDatabaseDateString(
				searchForm.value['departureDateFrom']
			),
			DateTimeUtility.toDatabaseDateString(
				searchForm.value['departureDateTo']
			),
			searchForm.value['type'],
			searchForm.value['onlyCancelled'],
			searchForm.value['includeArchivedTravelers'],
			searchForm.value['traveler'] === 'me',
			searchForm.value['onlyMyApprovals'],
			searchForm.value['traveler'] === 'traveler'
				? searchForm.value['travelerId']
				: null,
			searchForm.value['searchByInitiator'] === 'true',
			searchForm.value['requestStatus']
		);
	}
}
